/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaCipherIvSpc model module.
 * @module model/AqaCipherIvSpc
 * @version v0
 */
export default class AqaCipherIvSpc {
  /**
   * Constructs a new <code>AqaCipherIvSpc</code>.
   * @alias module:model/AqaCipherIvSpc
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCipherIvSpc</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCipherIvSpc} obj Optional instance to populate.
   * @return {module:model/AqaCipherIvSpc} The populated <code>AqaCipherIvSpc</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCipherIvSpc();
      if (data.hasOwnProperty('iv'))
        obj.iv = ApiClient.convertToType(data['iv'], 'Blob');
    }
    return obj;
  }
}

/**
 * @member {Blob} iv
 */
AqaCipherIvSpc.prototype.iv = undefined;

